import styled from 'styled-components';

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

export default FlexDiv;
